console.log('js/rebrand_dropdown.js -> v0.1.0');

$(() => {
	const reset = () => {
		$('.dropdown').removeClass('show')
		$('*').removeClass('dropdown-open');
	}

	$('.dropdown-toggler').click(function () {
		const myDropdown = $(this).find('.dropdown').first();
		const shown = myDropdown.hasClass('show');

		reset();

		if (shown) {
			myDropdown.removeClass('show');
			$(this).removeClass('dropdown-open');
			$('html,body').css('overflow', 'scroll');
		} else {
			myDropdown.addClass('show');
			$(this).addClass('dropdown-open');

			if ($(window).width() < 1024 && !$(this).hasClass('js-prevent-scroll')) {
				$('html,body').scrollTop($(this).offset().top - (10));
			}

			if ($(window).width() < 1024 && $(this).hasClass('js-prevent-scroll')) {
				$('html,body').css('overflow', 'hidden');
			}

			return false;
		}
	})

	$(document).click(function(e) {
		var target = e.target;

		if (
			!$(target).is('.dropdown-toggler') &&
			!$(target).parents().is('.dropdown-toggler')
		) {
			reset();
		}
	})
})
